"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactClickOutside = _interopRequireDefault(require("react-click-outside"));
var _reactCalendar = _interopRequireDefault(require("react-calendar"));
var _utils = require("@trs/utils");
var _Datepicker = _interopRequireDefault(require("./Datepicker.style"));
var _Input = _interopRequireDefault(require("../input/Input"));
var _excluded = ["errors", "id", "placeholder", "value", "format", "position", "disabled", "minDate", "clearable"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var DatePicker = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(DatePicker, _React$PureComponent);
  var _super = _createSuper(DatePicker);
  function DatePicker(props) {
    var _this;
    _classCallCheck(this, DatePicker);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onChange", function (date) {
      _this.props.onChange(date);
      _this.setState({
        isOpen: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      _this.setState({
        isOpen: true
      });
    });
    // eslint-disable-next-line react/no-unused-class-component-methods
    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function () {
      _this.setState({
        isOpen: false
      });
    });
    var isOpen = props.isOpen;
    _this.state = {
      isOpen: isOpen || false
    };
    return _this;
  }
  _createClass(DatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        errors = _this$props.errors,
        id = _this$props.id,
        placeholder = _this$props.placeholder,
        value = _this$props.value,
        format = _this$props.format,
        position = _this$props.position,
        disabled = _this$props.disabled,
        minDate = _this$props.minDate,
        clearable = _this$props.clearable,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "datepicker-wrapper"
      }, /*#__PURE__*/_react["default"].createElement(_Datepicker["default"], _extends({}, otherProps, {
        id: id,
        position: position
      }), /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({}, otherProps, {
        type: "text",
        disabled: disabled,
        placeholder: placeholder,
        icon: "ion-android-calendar",
        errors: errors,
        id: "".concat(id, "Input"),
        onFocus: this.handleFocus,
        value: (0, _utils.processDate)(value, format),
        readOnly: true
      })), isOpen && /*#__PURE__*/_react["default"].createElement(_reactCalendar["default"], _extends({}, otherProps, {
        minDate: minDate,
        onChange: this.onChange,
        isOpen: isOpen,
        value: value instanceof Date ? value : new Date()
      })), clearable && value ? /*#__PURE__*/_react["default"].createElement("span", {
        "aria-label": "Clear value",
        onClick: function onClick() {
          return _this2.onChange('');
        },
        className: "datepicker-clear-zone",
        title: "Clear value",
        onKeyDown: function onKeyDown() {
          return _this2.onChange('');
        },
        role: "button",
        tabIndex: "0"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "datepicker-clear"
      }, "\xD7")) : ''));
    }
  }]);
  return DatePicker;
}(_react["default"].PureComponent);
DatePicker.propTypes = {
  clearable: _propTypes["default"].bool,
  isOpen: _propTypes["default"].bool,
  /** A list of erros associated to the input */
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  /** Html id */
  id: _propTypes["default"].string.isRequired,
  /** Date format */
  format: _propTypes["default"].string,
  /** Html id */
  disabled: _propTypes["default"].bool,
  /** The short hint displayed in the input before the user enters a value. */
  placeholder: _propTypes["default"].string,
  /** The position where to render the calendar (relative to the input) */
  position: _propTypes["default"].oneOf(['top', 'left', 'bottom', 'right']),
  /** The date value */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /* A min date */
  minDate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  /** The date value */
  onChange: _propTypes["default"].func.isRequired
};
DatePicker.defaultProps = {
  clearable: false,
  value: null,
  isOpen: false,
  placeholder: 'dd/mm/yyyy',
  format: 'dd/MM/yyyy',
  minDate: null,
  position: 'bottom',
  errors: undefined,
  disabled: false
};
DatePicker.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "date",
      "type": null
    }],
    "returns": null
  }, {
    "name": "handleFocus",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "handleClickOutside",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "DatePicker",
  "props": {
    "clearable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "value": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "The date value",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "instanceOf",
          "value": "Date"
        }]
      },
      "required": false
    },
    "isOpen": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "placeholder": {
      "defaultValue": {
        "value": "'dd/mm/yyyy'",
        "computed": false
      },
      "description": "The short hint displayed in the input before the user enters a value.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "format": {
      "defaultValue": {
        "value": "'dd/MM/yyyy'",
        "computed": false
      },
      "description": "Date format",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "minDate": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "instanceOf",
          "value": "Date"
        }]
      },
      "required": false
    },
    "position": {
      "defaultValue": {
        "value": "'bottom'",
        "computed": false
      },
      "description": "The position where to render the calendar (relative to the input)",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'top'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'bottom'",
          "computed": false
        }, {
          "value": "'right'",
          "computed": false
        }]
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "A list of erros associated to the input",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "string"
          }
        }]
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Html id",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "id": {
      "description": "Html id",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "onChange": {
      "description": "The date value",
      "type": {
        "name": "func"
      },
      "required": true
    }
  }
};
var _default = (0, _reactClickOutside["default"])(DatePicker);
exports["default"] = _default;